module.exports = __webpack_public_path__ + "static/media/subhajit-mandal.aa03ad8e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/subhajit-mandal.jpeg
// module id = 1722
// module chunks = 157